module.exports = __webpack_public_path__ + "img/foto_6.9056df4e.png";